export default __webpack_public_path__ + "howitworks-epl-desktop-e6ea1dc837abe953e4d11a90001337fd.jpg";